// extracted by mini-css-extract-plugin
module.exports = {"ring":"_239c3b6789fc9f92c7f5c9fa08bacf63","lds-ring":"ea326e0d5dade04e25ead47ba04d70c4"};